export default __webpack_public_path__ + "static/media/retirecalc.aa04343d.png";